import React from "react"
import {useDispatch, useSelector} from "react-redux"

import {
  clearLeftWorkAreaState,
  clearActiveObjects,
  clearActiveObject,
} from "../../../redux/actions/product2dActions"

import "./leftworkheader.scss"

/**
 * Header for all left work area window
 * @component
 * @param  {object} props
 * @param  {function} props.handler - funtion for back
 * @param  {string} props.title - header title
 * @param  {boolean} props.activeHandler - show or not back button
 *
 * @example
 * const handler = () => {}
 * const title = 'title'
 * const activeHandler = false
 *
 * return (
 *  <LeftWorkHeader
 *    handler={handler}
 *    value={value}
 *    icon={icon}
 *    title={title}
 *    activeHandler={activeHandler}
 *  />
 * )
 */

const LeftWorkHeader = props => {
  const {title, handler = () => {}, activeHandler = false} = props
  const dispatch = useDispatch()
  const makFabric = useSelector(state => state.makFabric)

  /**
   * Close window
   */
  const handleClose = () => {
    makFabric.discradSelected()
    dispatch(clearLeftWorkAreaState())
    dispatch(clearActiveObjects())
    dispatch(clearActiveObject())
  }

  return (
    <div className="leftWorkHeaderContainer">
      <button
        onClick={handler}
        disabled={!activeHandler}
        className={`leftWorkHeaderBtn ${!activeHandler && "leftWorkHeaderDisabled"}`}
      >
        <img src="/assets/img/icons/back_icn.svg" alt="back" />
      </button>
      <span>{title}</span>
      <button className="leftWorkHeaderBtn" onClick={handleClose}>
        <img src="/assets/img/icons/close_icn.svg" alt="close" />
      </button>
    </div>
  )
}

export default LeftWorkHeader
